export default __webpack_public_path__ + "static/media/trr-food-pastry-4.a4812cdc.png";